import request from 'src/utils/request';

/**
 * 获取地区列表
 * @returns {Promise}
 */
export const getAreaList = () => {
    return request.get('/public/SysArea/GetList');
};

/**
 * 获取公司下拉框列表
 * @param {Object} params - 请求参数
 * @param {number} params.pageIndex - 当前页码
 * @param {number} params.pageSize - 每页数据量
 * @returns {Promise}
 */
export const getOrganizationList = (params) => {
    return request.get('/public/User/GetOrganizationList', {
        params
    });
};
